import {Injectable} from '@angular/core';
import {StaticTable} from '../static.table';
import {TtActivityType} from '../../interfaces/time-tracking/tt-activity-type';
import {db} from '../db.service';


@Injectable({
  providedIn: 'root'
})
export class TtActivityTypesTable extends StaticTable<TtActivityType> {
  constructor() {
    super(db.ttActivityTypes);
  }

  public override async getAll(): Promise<TtActivityType[]> {
    return this.table.orderBy(['sort+name']).toArray();
  }

}

